import './GenericList.scss';
import classNames from 'classnames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { NoData } from '@ui/NoData';
import React from 'react';
import { When } from 'react-if';
const defaultClassName = 'generic-list';
function GenericListInner({ className, empty = React.createElement(NoData, null), items, loading, renderItem, title }, ref) {
    const classes = className ? classNames(defaultClassName, className) : defaultClassName;
    return (React.createElement(React.Fragment, null,
        title && React.createElement("div", { className: 'periscope-list-title' }, title),
        React.createElement("div", { className: classes, ref: ref },
            React.createElement(LoadingSpinner, { spinning: loading },
                React.createElement(When, { condition: !loading && items.length === 0 }, empty), items === null || items === void 0 ? void 0 :
                items.map(renderItem)))));
}
export const GenericList = React.forwardRef(GenericListInner);
